/*@ngInject*/
const ClassCodePopulateSearchTextDirective = function ($rootScope, submissionConstant, formViewerConstant) {
    return {
        require: 'uiSelect',
        link: function ($scope, $element, attrs, $select) {
            let searchInput = $element.querySelectorAll('input.ui-select-search');

            function handleFocus() {
                $scope.$apply(function () {
                    $select.search = attrs.classCodePopulateSearchText;
                    $rootScope.$broadcast(submissionConstant.event.CLEAR_VISIBLE_TOOLTIP);
                    $scope.$ctrl.handleFocus();
                });
            }

            searchInput.on('focus', handleFocus);

            $scope.$on('$destroy', function () {
                searchInput.off('focus', handleFocus);
            });
        }
    };
};

angular.module('umCore')
    .directive('classCodePopulateSearchText', ClassCodePopulateSearchTextDirective);
